import * as React from "react";
const PlayFilledSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.87468837,5.45041947 L12.7318793,8.46657119 C13.1846512,8.7280426 13.1496124,9.3145752 12.7318793,9.53342881 L6.87468837,12.5495805 C6.53846154,12.7435913 6.00574179,12.5298767 6,12.0161517 L6,5.98384828 C5.99738462,5.60310364 6.38835144,5.22900391 6.87468837,5.45041947 Z" }));
PlayFilledSmall.displayName = "PlayFilledSmall";
var PlayFilledSmall_default = PlayFilledSmall;
export {
  PlayFilledSmall_default as default
};
